import React from 'react';
import '@contentful/forma-36-react-components/dist/styles.css';
import AnswerList from '../AnswerList/AnswerList';

// MPC Editor Component
const CarouselEditor = () => (
  <AnswerList
    answerOptions={{
      valid: false,
      text: true,
      asset: true,
    }}
  />
);

export default CarouselEditor;
